import { createFileRoute } from '@tanstack/react-router';
import GroupView from '../../../features/management/groups/group/view';
import {
  createPermissionGuard,
  getPermissionSet,
  GROUP_MANAGEMENT_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/verwaltung/gruppen/$groupId')({
  component: GroupView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(GROUP_MANAGEMENT_PERMISSIONS, 'READ'),
  ),
});

export const ViewGroupRoute = Route;
